export let everythingSelectedOther = "wsh0b";
export default {everythingSelectedOther};